module.exports = __webpack_public_path__ + "img/3f_circle.ed0ebd7b.png";